export default __webpack_public_path__ + "static/media/workplace.6452b28f.svg";